export function setSearchParamValue(param: string, value: string | undefined) {
  const url = new URL(location.href)
  value = value?.trim()
  if (value === undefined || value == '') url.searchParams.delete(param)
  else url.searchParams.set(param, value)
  return url.toString()
}

export function normalizedUrlPath(path: string) {
  return `/${path}/`.replace(/\/+/g, '/')
}
